/** Keep Indian mobile numbers to digits only, max 10. */
export const sanitizePhoneInput = (value = '') =>
  String(value).replace(/\D/g, '').slice(0, 10);

export const isPhoneFieldName = (name = '', type = 'text') =>
  type === 'tel' ||
  ['mobile', 'phone', 'phone_number', 'phoneNumber', 'visitorPhone'].includes(name);
